import { CnTable } from '@/components/cn-table';

export default CnTable;
